<template>
    <div class="pop-up">
       <el-form :model="form" :rules="rules" ref="form" size="small" label-width="100px">
            <el-form-item label="书目名称：" prop="bookname">
                <el-input v-model="form.bookname" type="text"></el-input>
            </el-form-item>
            <el-form-item label="ISBN：" prop="isbn">
                <el-input v-model="form.isbn" type="text"></el-input>
            </el-form-item>
            <el-form-item label="价格：" prop="price">
                <el-input v-model="form.price" type="text"></el-input>
            </el-form-item>
            <el-form-item label="作者：" prop='author' >
                <el-input v-model="form.author" type="text"></el-input>
            </el-form-item>
            <el-form-item label="出版社：" prop="pubname">
                <el-input v-model="form.pubname" type="text"></el-input>
            </el-form-item>
            <el-form-item label="出版时间：" prop="pubtime">
                <!-- <el-input v-model="form.pubtime" type="text"></el-input> -->
                <el-date-picker v-model="form.pubtime" type="date" placeholder="请选择出版时间" value-format="yyyy-MM-dd"
              size="medium" style="width:100%; ">
            </el-date-picker>
            </el-form-item>
       </el-form>
       <div class="btn_box" style="text-align:center;">
            <el-button class="btn_add_canle" size="small" @click="close()">取 消</el-button> 
            <el-button class="btn_add_sure" size="small" @click="submit()" type="primary">提 交</el-button>
       </div>
    </div> 
    </template>
    <script>
    import { Form, FormItem, Input, Button} from 'element-ui'
    import { updateNobook, noBookAdd } from '@/api/manage.js'
    export default {
        name: 'ImproveInfo',
        props: ['data', 'type'],
        data(){
            return {
                form:{
                    orgid: JSON.parse(localStorage.getItem('user')).orgGid,
                    userId: JSON.parse(localStorage.getItem('user')).gid,
                    username: JSON.parse(localStorage.getItem('user')).userName,
                    bookname:'',
                    isbn: '',
                    price: '',
                    author:'',
                    pubname:'',
                    pubtime: null,
                },
                rules:{
                    bookname: [
                        { required: true, message: '请输入书目名称！', trigger: 'blur' }
                    ],
                    isbn: [
                        { required: true, message: '请输入ISBN！', trigger: 'blur' }
                    ],
                    // price:[
                    //     { required: true, message: '请输入价格！', trigger: 'blur' }
                    // ], 
                    // author:[
                    //     { required: true, message: '请输入作者！', trigger: 'blur' }
                    // ],
                    // pubname:[
                    //     { required: true, message: '请输入出版社！', trigger: 'blur' }
                    // ],  
                    // pubtime:[
                    //     { required: true, message: '请输入出版时间！', trigger: 'blur' }
                    // ],
                     
                },
            }
        },
        watch:{
            
        },
        components: {Form, FormItem, Input, Button},
        created(){
            let vm = this;
            if(vm.type=='1'){
                vm.form.bookname = vm.data.bookname;
                vm.form.isbn = vm.data.isbn;
                vm.form.price = vm.data.price;
                vm.form.author = vm.data.author;
                vm.form.pubname = vm.data.pubname;
                vm.form.pubtime = vm.data.pubtime;
            }
        },
        mounted(){
            
        },  
        methods: {
            close(){//默认关闭事件
                this.$emit('close');
            },
            submit(){
                let vm = this;
                // 表单验证
                vm.$refs.form.validate((valid,obj) => {
                    if(valid){
                        console.log(vm.type,'vm.type');
                        if(vm.type == '0'){
                            noBookAdd(vm.form).then(res => {
                                if(res.status){
                                    vm.$message({message: '新增成功！',type: 'success'});
                                    vm.$emit('ok');
                                }else{
                                    vm.$message({message: res.errorMsg || '新增失败！',type: 'error'});
                                }
                            }).catch(res => {
                            });
                        }else if(vm.type == '1'){
                            let obj = vm.form;
                            obj.pkid = vm.data.pkid;
                            updateNobook(obj).then(res => {
                                if(res.status){
                                    vm.$message({message: '修改成功！',type: 'success'});
                                    vm.$emit('ok');
                                }else{
                                    vm.$message({message: res.errorMsg || '修改失败！',type: 'error'});
                                }
                            }).catch(res => {
                            });
                        }
                    }else{
                        return false;
                    }
                });
            }
        }
    }
    </script>
    <style lang = "scss" scoped>
    </style>
    
    
    


// WEBPACK FOOTER //
// src/views/Xtch/noBooklist/addBook.vue